﻿<script setup lang="ts">
    import { inject } from 'vue';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { ContextAccess } from '@shared/Root/Context.access';
    import { vTooltip } from '@shared/directives';

    interface IShareIconsParams {
        label?: string;
        size?: 'small' | 'large';
        type?: string;
        id: string;
    }

    const props = withDefaults(defineProps<IShareIconsParams>(), {
        size: 'small',
        type: 'Issues',
    });
    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const contextAccess: ContextAccess = injectorAccess.injector.get(ContextAccess);

    const baseUrl = () => {
        return contextAccess.state.currentAccount!.PublicEventUrl.PublicHost;
    };

    const getLabel = () => {
        return props.label || $Resources.SendingShareHeading;
    };
</script>

<template>
    <h4 class="m-0-t" v-show="props.size == 'large'">{{ getLabel() }}</h4>

    <ul class="social-share d-flex align-items-baseline list-unstyled m-sm-b" :class="props.size == 'small' ? 'social-share-sm gap-xs' : 'gap-sm'">
        <li v-if="props.size == 'small'" class="m-xs-r">
            <h4 class="h5 m-0-all">{{ getLabel() }}:</h4>
        </li>
        <li>
            <a v-tooltip.top="$Resources.ShareLinkLabel" :href="baseUrl() + '/' + props.type + '/' + props.id" target="_blank" rel="noopener">
                <i class="fa fa-link"></i>
                <span class="sr-only">{{ $Resources.ShareLinkLabel }}</span>
            </a>
        </li>
        <li>
            <a
                v-tooltip.top="$Resources.ShareOnFacebookActionLabel"
                :href="'https://www.facebook.com/share.php?u=' + baseUrl() + '/' + props.type + '/' + props.id"
                target="_blank"
                rel="noopener">
                <i class="fa fa-facebook"></i>
                <span class="sr-only">{{ $Resources.ShareOnFacebookActionLabel }}</span>
            </a>
        </li>
        <li class="align-self-center">
            <a
                v-tooltip.top="$Resources.ShareOnTwitterActionLabel"
                :href="'https://twitter.com/intent/tweet?text=' + baseUrl() + '/' + props.type + '/' + props.id"
                target="_blank"
                rel="noopener">
                <svg :width="props.size === 'large' ? 16 : 14" viewBox="0 0 24 24" aria-hidden="true">
                    <g>
                        <path
                            d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path>
                    </g>
                </svg>
                <span class="sr-only">{{ $Resources.ShareOnTwitterActionLabel }}</span>
            </a>
        </li>
        <li>
            <a
                v-tooltip.top="$Resources.ShareOnLinkedInActionLabel"
                :href="'https://www.linkedin.com/sharing/share-offsite/?url=' + baseUrl() + '/' + props.type + '/' + props.id"
                target="_blank"
                rel="noopener">
                <i class="fa fa-linkedin"></i>
                <span class="sr-only">{{ $Resources.ShareOnLinkedInActionLabel }}</span>
            </a>
        </li>
    </ul>
</template>
